module.exports = __webpack_public_path__ + "static/media/slider-creative-agency-slide-01-bg.be423893.jpg";